import { render } from "./FullWidth.vue?vue&type=template&id=21274a86"
import script from "./FullWidth.vue?vue&type=script&lang=js"
export * from "./FullWidth.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__